__turbopack_context__.v({
  "cardContainer": "serviceCardsCard-module-scss-module__2pv5dW__cardContainer",
  "cardDescription": "serviceCardsCard-module-scss-module__2pv5dW__cardDescription",
  "cardTitle": "serviceCardsCard-module-scss-module__2pv5dW__cardTitle",
  "cardWrapper": "serviceCardsCard-module-scss-module__2pv5dW__cardWrapper",
});
